export const RECEIVE_SCENARIOS = 'RECEIVE_SCENARIOS';
export const RECEIVE_SCENARIO = 'RECEIVE_SCENARIO';
export const ERROR = 'ERROR';
export const ALERT = 'ALERT';
